import React from 'react'
import { Tooltip } from 'antd'
import { LoginOutlined, LogoutOutlined } from '@ant-design/icons'
import { Link, withRouter } from 'react-router-dom'
import classnames from 'classnames'

import VibalLogo from '../../assets/vibal_logo.png'

import './Header.scss'

class Header extends React.Component {
    constructor(props) {
        super(props)

        this.state={
            logged_in: this.props.isLoggedIn
        }
    }

    checkIfActivePath = (current_path) => {
        const { history } = this.props
        const { location } = history

        if(current_path === location.pathname) {
            return true
        } else {
            return false
        }
        
    }

    render() {
        const { onLogin, onLogout, isLoggedIn } = this.props

        return (
            <div
                className="header_container"
            >
                <Link to="/">
                    <img
                        className="header-logo"
                        src={VibalLogo}
                        alt="logo"
                    />
                </Link>
                <span className="header__tabs">
                    <Link to="/" 
                        style={{ 
                            display: isLoggedIn? null : 'none'
                        }}
                    >
                        <div className={classnames("header__tabs--tab left-bordered", {
                            'header__tabs--tab--active': this.checkIfActivePath('/')
                        })}>
                            Home
                        </div>
                    </Link>
                    <Link to="/admin"
                        style={{ 
                            display: isLoggedIn? null : 'none'
                        }}
                    >
                        <div className={classnames('header__tabs--tab', {
                            'header__tabs--tab--active': this.checkIfActivePath('/admin')
                        })}>
                            Admin
                        </div>
                    </Link>
                    {isLoggedIn?
                        <div
                            className="login__span"
                            onClick={e => onLogout()}
                        >
                            <LogoutOutlined className="login__icon"/> Log out
                        </div>
                        :
                        <div
                            className="login__span"
                            onClick={e => onLogin()}
                        >
                            <LoginOutlined className="login__icon"/> Log in
                        </div>
                    }
                </span>
            </div>
        )
    }
}

export default withRouter(Header)